import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { allCategoriesAction, clearErrors, createCategoryAction, toggleCategoriesAction, updateCategoryAction, deleteCategoryAction } from '../../redux/actions/userActions';
import { toast } from 'react-toastify';
import api from '../../api';



const Categories = () => {

    const dispatch = useDispatch();


    const { loading, error, message } = useSelector(state => state.createCategory)
    const { categories } = useSelector(state => state.allCategories)

    const [name, setnName] = useState("")
    const [complexity_level, setComplexity_level] = useState("")
    const [localCategories, setLocalCategories] = useState([])

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [editName, setEditName] = useState("");
    const [editComplexity, setEditComplexity] = useState("easy");

    useEffect(() => {
        if (categories) {
            setLocalCategories(categories);
        }
    }, [categories]);

    const handleMoveUp = async (index) => {
        if (index === 0) return;
        const newCategories = [...localCategories];
        const temp = newCategories[index];
        newCategories[index] = newCategories[index - 1];
        newCategories[index - 1] = temp;
        setLocalCategories(newCategories);
        await saveOrder(newCategories);
    };

    const handleMoveDown = async (index) => {
        if (index === localCategories.length - 1) return;
        const newCategories = [...localCategories];
        const temp = newCategories[index];
        newCategories[index] = newCategories[index + 1];
        newCategories[index + 1] = temp;
        setLocalCategories(newCategories);
        await saveOrder(newCategories);
    };

    const saveOrder = async (updatedCategories) => {
        const orders = updatedCategories.map((cat, idx) => ({
            id: cat.id,
            sort_order: idx
        }));
        try {
            const { data } = await api.put('/api/v1/update-category-order', { orders });
            if (data.success) {
                toast.success("Order updated successfully");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update order");
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!name) {
            toast.error("Please enter your name");
            return;
        }

        if (!complexity_level) {
            toast.error("Please select complexity level");
            return;
        }

        dispatch(createCategoryAction({ name, complexity_level }))
    }


    useEffect(() => {
        if (message) {
            toast.success(message)
            dispatch({ type: "CREATE_CATEGORY_RESET" })
            dispatch(allCategoriesAction())
            setComplexity_level("")
            setnName("")
        }
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }
    }, [message, error, dispatch])




    useEffect(() => {
        dispatch(allCategoriesAction())
    }, [dispatch])

    const handleEdit = (category) => {
        setSelectedCategory(category);
        setEditName(category.name);
        setEditComplexity(category.complexity_level);
        setIsEditModalOpen(true);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this category?")) {
            dispatch(deleteCategoryAction(id));
        }
    };

    const handleUpdateSubmit = () => {
        dispatch(updateCategoryAction({ id: selectedCategory.id, name: editName, complexity_level: editComplexity }));
        setIsEditModalOpen(false);
    };

    const handleToggle = (category_id, is_active) => {


        console.log(category_id, is_active)

        dispatch(toggleCategoriesAction(category_id, is_active))

    }

    return (
        <Fragment>
            <form onSubmit={handleSubmit} className="mt-[2vmax]" >
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-[1.5vmax] items-end' >
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Category Name <span className='text-red-500'>*</span></label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setnName(e.target.value)}
                            className='w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700'
                            placeholder='ex. General'
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Complexity Level <span className='text-red-500'>*</span></label>
                        <div className="relative mt-[0.5vmax]">
                            <select
                                value={complexity_level}
                                onChange={(e) => setComplexity_level(e.target.value)}
                                className='w-full pl-[1vmax] pr-[2vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] appearance-none font-medium text-gray-700'
                            >
                                <option value="">--Select Complexity Level</option>
                                <option value="easy">Easy</option>
                                <option value="medium">Medium</option>
                                <option value="complex">Complex</option>
                            </select>
                            <span className="absolute right-[1vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                <i className="fa-solid fa-chevron-down text-xs"></i>
                            </span>
                        </div>
                    </div>

                    <div className='flex justify-end gap-3 items-center' >
                        <button className='bg-gray-100 hover:bg-gray-200 text-gray-700 px-[1.5vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors' type='reset' >Cancel</button>
                        <button 
                            className={`bg-indigo-600 hover:bg-indigo-700 text-white px-[2vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed`} 
                            type='submit' 
                            disabled={loading || name === "" || complexity_level === ""}   
                        >
                            {loading ? "Saving..." : "Save"}
                        </button>
                    </div>
                </div>
            </form>

            <div className="mt-[3vmax] overflow-x-auto">
                <h3 className="text-[1.2vmax] font-bold text-gray-800 mb-[1vmax]" >Categories List</h3>
                <div className="flex bg-gray-50 py-[1vmax] rounded-lg w-[240%] lg:w-full mb-[1vmax]">
                    <span className='flex-[0.5] text-center text-gray-600 font-bold uppercase text-[0.8vmax]' >No.</span>
                    <span className='flex-[1] text-center text-gray-600 font-bold uppercase text-[0.8vmax]' >Name</span>
                    <span className='flex-1 text-center text-gray-600 font-bold uppercase text-[0.8vmax]' >Complexity Level</span>
                    <span className='flex-1 text-center text-gray-600 font-bold uppercase text-[0.8vmax]' >Status</span>
                    <span className='flex-1 text-center text-gray-600 font-bold uppercase text-[0.8vmax]' >Action</span>
                </div>
                {localCategories?.length > 0 ? (
                    localCategories.map((category, index) => (
                        <div key={category.id} className="flex w-[240%] lg:w-full py-[1vmax] border border-gray-100 bg-white rounded-xl shadow-sm mb-[0.5vmax] items-center transition-all hover:shadow-md">
                            <span className='flex-[0.5] text-center text-gray-500 font-bold text-[0.9vmax] flex items-center justify-center gap-2' >
                                <span>{index + 1}</span>
                                <div className="flex flex-col text-xs text-indigo-600">
                                    <button 
                                        type="button"
                                        onClick={() => handleMoveUp(index)} 
                                        disabled={index === 0}
                                        className="hover:text-indigo-800 disabled:text-gray-300"
                                    >
                                        <i className="fa-solid fa-chevron-up"></i>
                                    </button>
                                    <button 
                                        type="button"
                                        onClick={() => handleMoveDown(index)} 
                                        disabled={index === localCategories.length - 1}
                                        className="hover:text-indigo-800 disabled:text-gray-300"
                                    >
                                        <i className="fa-solid fa-chevron-down"></i>
                                    </button>
                                </div>
                            </span>
                            <span className='flex-[1] text-center text-gray-800 font-bold text-[0.9vmax]' >{category.name}</span>
                            <span className='flex-1 text-center flex justify-center'>
                                <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider
                                    ${category.complexity_level === "easy" ? "text-green-700 bg-green-50" : 
                                      category.complexity_level === "medium" ? "text-yellow-700 bg-yellow-50" : "text-red-700 bg-red-50"}`}
                                >
                                    {category.complexity_level}
                                </span>
                            </span>
                            <span className='flex-1 text-center flex justify-center'>
                                <span className={`px-[0.8vmax] py-[0.2vmax] rounded-full text-[0.8vmax] font-bold uppercase tracking-wider
                                    ${category.is_active === 1 ? 'text-green-700 bg-green-50' : "text-red-700 bg-red-50"}`}
                                >
                                    {category.is_active === 1 ? "Active" : "Inactive"}
                                </span>
                            </span>
                            <div className="flex-1 text-center flex justify-center gap-2">
                                <button className={`px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white
                                    ${category.is_active === 0 ? "bg-emerald-600 hover:bg-emerald-700" : "bg-rose-600 hover:bg-rose-700"} 
                                    ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                                    onClick={() => handleToggle(category.id, category.is_active === 1 ? 0 : 1)}
                                    disabled={loading}
                                >
                                    {category.is_active === 0 ? "Activate" : "Deactivate"}
                                </button>
                                <button className="px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white bg-blue-600 hover:bg-blue-700"
                                    onClick={() => handleEdit(category)}
                                >
                                    Edit
                                </button>
                                <button className="px-[1vmax] py-[0.4vmax] rounded-lg text-[0.8vmax] font-bold transition-colors text-white bg-red-600 hover:bg-red-700"
                                    onClick={() => handleDelete(category.id)}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center text-[1.2vmax] text-gray-400 py-[2vmax]">No categories found</div>
                )}
            </div>

            {isEditModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg w-[30vmax]">
                        <h2 className="text-xl font-bold mb-4">Edit Category</h2>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Name</label>
                            <input
                                type="text"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Complexity Level</label>
                            <select
                                value={editComplexity}
                                onChange={(e) => setEditComplexity(e.target.value)}
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            >
                                <option value="easy">Easy</option>
                                <option value="medium">Medium</option>
                                <option value="complex">Complex</option>
                            </select>
                        </div>
                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setIsEditModalOpen(false)}
                                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateSubmit}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment >
    )
}

export default Categories;